import React from 'react';

import ArticleCardTopic from '../components/ArticleCardTopic';

const section1FactoryFactory = (props) => {
  const {
    topic,
  } = props;

  const section1Factory = () => {
    return (
      <ArticleCardTopic
        topic={topic}
      />
    );
  };

  return section1Factory;
};

export default section1FactoryFactory;
